var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2295_450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9993 13.9998C20.3845 14 20.7549 14.1484 21.0336 14.4142C21.3124 14.6801 21.4783 15.043 21.4968 15.4277C21.5153 15.8125 21.3851 16.1896 21.1331 16.481C20.8811 16.7724 20.5267 16.9556 20.1433 16.9928L19.9993 16.9998H7.62026L9.06026 18.4398C9.33303 18.7116 9.49083 19.0779 9.50099 19.4628C9.51116 19.8477 9.3729 20.2218 9.11486 20.5076C8.85682 20.7934 8.49875 20.969 8.11479 20.9981C7.73084 21.0272 7.3504 20.9075 7.05226 20.6638L6.93826 20.5608L3.10926 16.7308C2.13526 15.7568 2.76926 14.1138 4.10026 14.0058L4.24026 13.9998H19.9993ZM14.9393 3.43981C15.2016 3.17721 15.5521 3.02122 15.9228 3.00201C16.2935 2.9828 16.6582 3.10173 16.9463 3.33581L17.0603 3.43881L20.8893 7.26881C21.8633 8.24281 21.2293 9.88581 19.8983 9.99381L19.7583 9.99981H3.99926C3.61404 9.99962 3.24366 9.85124 2.96487 9.5854C2.68608 9.31957 2.52025 8.95667 2.50173 8.5719C2.48322 8.18713 2.61345 7.80998 2.86543 7.51861C3.11742 7.22724 3.47184 7.04398 3.85526 7.00681L3.99926 6.99981H16.3783L14.9383 5.55981C14.6574 5.27856 14.4996 4.89731 14.4996 4.49981C14.4996 4.10231 14.6584 3.72106 14.9393 3.43981Z",
    fill: "#0FC000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2295_450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "static/media/transfer-icon.efe618555ca94b1092f0d996a94336ee.svg";
export { ForwardRef as ReactComponent };